import useProductCategories from '../../hooks/useProductCategories'
import { useSearchParams } from 'react-router-dom'
import { Squares2X2Icon } from '@heroicons/react/24/outline'

export default function CategoriesFilter({ setPage = () => {} }) {
  const { categories } = useProductCategories()
  const [searchParams, setSearchParams] = useSearchParams()
  const selectedCategorySlug = searchParams.get('category')

  const handleCategorySelect = (categorySlug) => {
    setPage(1)
    searchParams.delete('category')
    if (categorySlug) {
      searchParams.set('category', categorySlug)
    }
    setSearchParams(searchParams)
  }

  return (
    <div className="flex items-center overflow-scroll gap-x-2 py-2 overflow-x-auto scrollbar-hide border-y border-gray-200 mb-4">
      <Squares2X2Icon className="h-6 w-6 text-gray-700 flex-shrink-0 ml-2" />
      <button
        onClick={() => handleCategorySelect(null)}
        className={`py-1 px-3 text-sm font-medium whitespace-nowrap flex-shrink-0 rounded-md ${
          !selectedCategorySlug
            ? 'text-secondary-600 font-semibold'
            : 'text-gray-700 hover:text-secondary-600'
        }`}
      >
        All
      </button>
      {categories.map((category) => (
        <button
          key={category.id}
          onClick={() => handleCategorySelect(category.categorySlug)}
          className={`py-1 px-3 text-sm font-medium whitespace-nowrap flex-shrink-0 rounded-md ${
            selectedCategorySlug === category.categorySlug
              ? 'text-secondary-600 font-semibold'
              : 'text-gray-700 hover:text-secondary-600'
          }`}
        >
          {category.name}
        </button>
      ))}
    </div>
  )
}
